import { createFileRoute } from '@tanstack/react-router';
import { getCustomerOptions } from '../../../../features/customer/customer/queryOptions';
import { validateSearch } from '../../../../utils/pagination';

import { useLoaderData } from '@tanstack/react-router';
import { BasicCustomerInformation } from '../../../../features/customer/customer/basic-customer-information';
import { InsuranceList } from '../../../../features/customer/customer/insurance-list';
import { RecentNoteCard } from './../../../../features/shared/note/recent-note-card';
import { useSuspenseQuery } from '@tanstack/react-query';
import { getNotesOptions } from './../../../../features/customer/notes/queryOptions';
import { CardList, TextButtonLink } from '@maia/ui';
import { useDrawerStore } from './../../../../stores/drawer.store';
import { getActivitiesOptions } from './../../../../features/customer/activities/queryOptions';
import { ActivityCard } from './../../../../features/shared/activity/activity-card';
import { getTasksOptions } from './../../../../features/customer/tasks/queryOptions';
import { OpenTaskWidget } from './../../../../features/shared/task/open-task-widget';
import { useDocumentPreviewStore } from './../../../../stores/document-preview.store';

export const Route = createFileRoute(
  '/_authenticated/customers/$guid/_layout/',
)({
  component: Page,
  loaderDeps: ({ search: { page } }) => ({ page }),
  loader: ({ context: { queryClient }, params: { guid } }) =>
    queryClient.ensureQueryData(getCustomerOptions(guid)),
  validateSearch: validateSearch,
});

export function Page() {
  const { openDrawer } = useDrawerStore();
  const openDocumentPreview = useDocumentPreviewStore((state) => state.open);

  const customer = useLoaderData({
    from: '/_authenticated/customers/$guid/_layout/',
  });

  const { data: notes } = useSuspenseQuery(
    getNotesOptions(customer.guid, { limit: 3 }),
  );

  const { data: activities } = useSuspenseQuery(
    getActivitiesOptions(customer.guid, { limit: 3 }),
  );

  const { data: tasks } = useSuspenseQuery(
    getTasksOptions(customer.guid, { limit: 3 }),
  );

  return (
    <>
      <div className="col-span-4 space-y-32">
        <BasicCustomerInformation customer={customer} />
        <InsuranceList />
      </div>

      <div className="col-span-8 grid grid-cols-2 gap-32">
        <div className="col-span-full">
          <CardList
            title="Openstaande taken"
            resource="opeenstaande taken"
            items={tasks?.response ?? []}
            render={(task) => (
              <OpenTaskWidget
                task={task}
                onOpen={() => openDrawer({ type: 'task', data: task })}
              />
            )}
            action={
              <TextButtonLink
                size="tiny"
                to="/customers/$guid/tasks"
                params={{ guid: customer.guid }}
              >
                Bekijk alles
              </TextButtonLink>
            }
          />
        </div>

        <div className="col-span-1">
          <CardList
            title="Laatste activiteiten"
            resource="laatste activiteiten"
            items={activities?.response ?? []}
            render={(activity) => (
              <ActivityCard
                title={activity.title}
                subtitle={activity.message}
                date={activity.date}
                icon={activity.icon}
                onOpen={() => {
                  activity.type === 'Email'
                    ? openDocumentPreview({
                        type: 'email',
                        title: activity.message,
                        data: activity.content,
                      })
                    : openDrawer({ type: 'activity', data: activity });
                }}
              />
            )}
            action={
              <TextButtonLink
                size="tiny"
                to="/customers/$guid/activities"
                params={{ guid: customer.guid }}
              >
                Bekijk alles
              </TextButtonLink>
            }
          />
        </div>

        <div className="col-span-1">
          <CardList
            title="Recente notities"
            resource="recente notities"
            items={notes?.response ?? []}
            render={(note) => (
              <RecentNoteCard
                note={note}
                onClick={() => openDrawer({ type: 'note', data: note })}
              />
            )}
            action={
              <TextButtonLink
                size="tiny"
                to="/customers/$guid/notes"
                params={{ guid: customer.guid }}
              >
                Bekijk alles
              </TextButtonLink>
            }
          />
        </div>
      </div>
    </>
  );
}
